import { Model, Signal, View } from '@lernetz/ts-lib';
import { node } from '../utility/node';
import { context } from '@lernetz/ts-lib/src/view/Template';

import {Locale} from '../Locale';
import navBarTemplate from './NavBar.html';
import navBarOnStartPageTemplate from './NavBarOnStartPage.html';
import debounce from '../utility/debounce';


export type NavigationRequest = 'toggle-sidepanel';


class NavBar extends Model {

    public readonly locales: Locale[];
    public readonly navigate: Signal<NavigationRequest>;
    public readonly title: string;

    public activeLocale: Locale;

    public constructor(title: string, locales: Locale[]) {
        super({
            activeLocale: null,
            locales,
            title,
        });

        this.navigate = new Signal<NavigationRequest>();

        for (const locale of locales) {
            if (locale.active) {
                this.activeLocale = locale;
                break;
            }
        }
    }
}


export class NavBarView extends View<NavBar> {

    private logo: Element;
    private logoScrolled: Element;

    constructor(title: string, locales: Locale[]) {
        super({ data: new NavBar(title, locales), template: context.isStartPage() ? navBarOnStartPageTemplate : navBarTemplate });
    }

    init() {
        if (context.isStartPage()) {
            // set up scroll-dependent logo swapping:
            this.logo = this.node.querySelector('.logo.-for-desktop');
            this.logoScrolled = this.node.querySelector('.logo.-for-desktop-if-scrolled');
            setTimeout(() => {
                const debouncedUpdateFn = debounce(this.updateLogos.bind(this), 25, false);
                window.addEventListener('scroll', debouncedUpdateFn);
                window.addEventListener('resize', debouncedUpdateFn);
                debouncedUpdateFn();
            }, 500);
        }
    }

    updateLogos() {
        const HIDDEN_CLASS = '-hidden';
        const navBarRect = this.node.getBoundingClientRect();
        const logoToggleYOffset = navBarRect.top - navBarRect.height + window.pageYOffset;

        const cond = window.pageYOffset >= logoToggleYOffset;
        this.logo.classList.toggle(HIDDEN_CLASS, cond);
        this.logoScrolled.classList.toggle(HIDDEN_CLASS, !cond);
    }
}
